import { InvoiceLineItems } from "../interfaces/Gig";

const getInvoiceItemAmount = (lineItem: InvoiceLineItems) => {
  return lineItem.quantity * lineItem.rate;
};
export default getInvoiceItemAmount;
